export default "__VITE_ASSET__C0Lmlc1B__"